import { AuthProvider } from "@mattfinkel/common-web";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "./index.css";
import App from "./App";
import { auth } from "./firebase";
import { api } from "./lib/api";

// `auth` and `api` are passed IN rather than imported by the provider. A
// package cannot read this app's `import.meta.env`, and injecting the two
// firebase/auth calls is also what keeps app-level tests honest: vitest
// externalizes node_modules, so a `vi.mock("firebase/auth", ...)` here would
// not reach the provider and the test would quietly exercise the real SDK.
//
// BrowserRouter wraps AuthProvider rather than the other way round: the
// provider never navigates, and this way a route can be read during the
// verifying state without remounting the router when auth settles.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider auth={auth} api={api}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
